import React from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import classnames from 'classnames';
import useStyles from './styles';
import Header from '../Header';
import Footer from '../Footer';
import Sidebar from '../Sidebar';
import Dashboard from '../../pages/dashboard';
import List from '../../pages/incidents/List';
import Create from '../../pages/incidents/Create';
import App from '../../pages/apps/App';
import Usages from '../../pages/api-usages';

function Layout(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Header history={props.history} sidebar />
            <Sidebar />
            <div className={classes.container}>
                <div
                    className={classnames(classes.content, {
                        [classes.contentShift]: true
                    })}
                >
                    <div className={classes.fakeToolbar} />
                    <Switch>
                        <Route exact path="/app/dashboard" component={Dashboard} />
                        <Route exact path="/app/incidents/list" component={List} />
                        <Route exact path="/app/incidents/create" component={Create} />
                        <Route exact path="/app/application" component={App} />
                        <Route exact path="/app/apiUsage" component={Usages} />
                        <ConditionalRoute exact path="/app/incidents/edit" component={Create} />
                    </Switch>
                </div>
            </div>
            <Footer history={props.history} />
        </div>
    );
}

function ConditionalRoute({ component, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) =>
                !props.location.state ? (
                    <Redirect to="/app/incidents/list" />
                ) : (
                    React.createElement(component, props)
                )
            }
        />
    );
}

export default withRouter(Layout);
